import { ProjectData, SimusPlanData } from '@/interfaces/api_interface';

const Project = {
    state: {
        project: {},
        simusPlan: [],
    },

    getters: {
        getProjectData: (state: { project: ProjectData }) => {
            return state.project;
        },
        getSimusPlan: (state: { simusPlan: Record<string, string | number>[] }) => {
            return state.simusPlan;
        },
    },

    mutations: {
        // 设置页面数据
        setProjectData: (state: { project: ProjectData }, data: ProjectData) => {
            state.project = data;
        },
        // 设置财务数据
        setProjectDataWithFinance: (state: { simusPlan: SimusPlanData[] }, data: { id: string; data: { data: Record<string, string | number> }[] }) => {
            state.simusPlan.forEach((x) => {
                if (x.id === data.id) {
                    x.finance_overview = data.data[0];
                }
            });
        },
        // 设置环保数据
        setProjectDataWithEnvironment: (
            state: { simusPlan: SimusPlanData[] },
            data: { id: string; data: { results: { data: Record<string, string | number> }[] } },
        ) => {
            state.simusPlan.forEach((x) => {
                if (x.id === data.id) {
                    x.environment_evaluation = data.data.results[0];
                }
            });
        },
        // 设置能效数据
        setProjectDataWithEnergy: (
            state: { simusPlan: SimusPlanData[] },
            data: { id: string; data: { results: { data: Record<string, string | number> }[] } },
        ) => {
            state.simusPlan.forEach((x) => {
                if (x.id === data.id) {
                    x.energy_evaluation = data.data.results[0];
                }
            });
        },
        // 多选方案
        setSimusPlan: (state: { simusPlan: Record<string, string | number>[] }, data: Record<string, string | number>[]) => {
            state.simusPlan = data;
        },
        // 增加taskId
        setProjectDataWithTaskId: (state: { project: ProjectData }, data: { id: number; taskId: string }) => {
            state.project.simus.forEach((item) => {
                if (item.id === data.id) {
                    item.taskId = data.taskId;
                }
            });
        },
    },
};

export default Project;
